module.exports = __webpack_public_path__ + "static/img/ceshi1.cc9da44.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/ceshi1.jpeg
// module id = IcSa
// module chunks = 1